import { Plug } from 'lucide-react'

import { defineModule } from '@/lib/module-routes'
import { EAUTOMATE_PERMISSIONS } from '@/lib/permissions'

import { eautomateSettingsRoute } from './routes'

export const eautomateModule = defineModule({
  routes: [eautomateSettingsRoute],
  navigation: {
    settings: [
      {
        to: '/$entityId/settings/eautomate',
        label: 'e-automate',
        icon: Plug,
        permission: EAUTOMATE_PERMISSIONS.read,
        section: 'settings',
        order: 50,
      },
    ],
  },
})
